module.exports = __webpack_public_path__ + "assets/img/spoken_gif.14bd4adf.png";